'use strict';

var _el,
    /**
     * The Basic notification popup.
     * @type {{setElement: Function, show: Function}}
     */
    Notification = {
        /**
         * In order to use popup notification, this are hosted in the main App module. And then,
         * available through this Object for the rest of the application.
         * @param notificationEl
         */
        setElement(notificationEl) {
            _el = notificationEl;
        },

        /**
         * Show the message with the given message and type of them.
         * @param message
         * @param type
         */
        show(message, type) {
            _el.show(message, type ? type : 'error');
        },

        /**
         * Show the message with the given message and type of them.
         * @param message
         * @param type
         */
        showImmediately(message, type) {
            _el.showImmediately(message, type ? type : 'error');
        }
    };

module.exports = Notification;



/** WEBPACK FOOTER **
 ** ./src/components/Notification/Notification.js
 **/